import { AppRoute } from '@modules/core/navigation/app-route.enum';

export const AUTH0_SCOPE = 'openid profile email';
export const AUTH0_CACHE_LOCATION = 'localstorage';
export const AUTH0_REDIRECT_URI = `${window.location.origin}/${AppRoute.authCallback}`;
export const AUTH0_LOCAL_STORAGE_IDENTIFIER = '@@auth0spajs@@';
